export const MERCHANT_LEVEL = 'Merchant Level';
export const STORE_LEVEL = 'Store Level';
export const MERCHANT_HOME_PATH = '/dashboard';
export const MERCHANT_HOME_PATH_NEW = '/home';
export const FRANCHISE_MANAGEMENT = 'sidebar.merchant.franchise';
export const MULTI_BRAND_MANAGEMENT = 'sidebar.merchant.multi-brand';
